/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Content.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import * as fromFlow from 'Logic/ViewsFlow.js'
import ButtonRed from 'DesignSystem/ButtonRed/view.js'
import Info from 'DesignSystem/Info/view.js'
import React from 'react'
import { css } from "emotion"

let styles = {}
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
alignItems: "center",
marginTop: 16})
styles.Vertical = css({label: 'Vertical',
  width: "55%",
marginRight: "auto"})

export default function Content({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  viewPath= "/App/MyAccount/Content/Profile/Content/Utilization/Item/Content/Provide/Content/Data/Verify/InvalidData/Content"
}) {
    
    
    
    let flow = fromFlow.useFlow()
let setFlowTo = fromFlow.useSetFlowTo(viewPath)
    
    

  return (<React.Fragment
>
<div
 data-testid="Content.Horizontal"
 data-view-path="/App/MyAccount/Content/Profile/Content/Utilization/Item/Content/Provide/Content/Data/Verify/InvalidData/Content"
 className={`views-block ${styles.Horizontal}`}
>
<div
 data-testid="Content.Vertical"
 data-view-path="/App/MyAccount/Content/Profile/Content/Utilization/Item/Content/Provide/Content/Data/Verify/InvalidData/Content"
 className={`views-block ${styles.Vertical}`}
>
<Info
 data-testid="Content.Info"
 data-view-path="/App/MyAccount/Content/Profile/Content/Utilization/Item/Content/Provide/Content/Data/Verify/InvalidData/Content"
viewPath={`${viewPath}/Info`}
 color="rgba(255,74,58, 1)"
 text="We've detected invalid fields in the imported data."
/>
<Info
 data-testid="Content.Info:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/Utilization/Item/Content/Provide/Content/Data/Verify/InvalidData/Content"
viewPath={`${viewPath}/Info`}
 marginTop={4}
 color="rgba(255,74,58, 1)"
 text="Please fix those in the spreadsheet and upload it again."
/>
</div>
<ButtonRed
 data-testid="Content.ButtonRed"
 data-view-path="/App/MyAccount/Content/Profile/Content/Utilization/Item/Content/Provide/Content/Data/Verify/InvalidData/Content"
viewPath={`${viewPath}/ButtonRed`}
 onClick={() => setFlowTo("/App/MyAccount/Content/Profile/Content/Utilization/Item/Content/Provide/Content/Data/Upload")}
 isSelected={flow.has("/App/MyAccount/Content/Profile/Content/Utilization/Item/Content/Provide/Content/Data/Upload")}
 text="Reset Imported Data"
/>
</div>
{children}
</React.Fragment>)
}